"use client";

/**
 * Exit browser fullscreen without throwing when exits race (native player chrome vs ours).
 * Browsers may reject with {@link DOMException} `InvalidStateError` during transitions.
 */
export async function safeExitDocumentFullscreen(): Promise<void> {
	try {
		if (document.fullscreenElement != null) {
			await document.exitFullscreen();
		}
	} catch {
		/* noop */
	}
}
